import { EncTotals } from '../Encodings/Totals';
export class EncodedTotals {
    constructor(totals = EncTotals.make(), lookup) {
        this.totals = totals;
        this.lookup = lookup;
        this.grand = new EncodedGrandTotals(totals.grand);
    }
    serialize() {
        return {
            grand: this.grand.serialize(),
        };
    }
}
export class EncodedGrandTotals {
    constructor(grand) {
        this.row = grand.row;
        this.column = grand.column;
    }
    enable(direction) {
        this[direction] = true;
    }
    disable(direction) {
        this[direction] = false;
    }
    serialize() {
        return {
            row: this.row,
            column: this.column,
        };
    }
}
